export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    // breakpoints taken from bulma/sass/utilities/initial-variables.sass
    isMobile() {
      return this.windowWidth < 769;
    },
    isTablet() {
      return this.windowWidth >= 769 && this.windowWidth < 960;
    },
    isDesktop() {
      return this.windowWidth >= 960 && this.windowWidth < 1152;
    },
    isWidescreen() {
      return this.windowWidth >= 1152 && this.windowWidth < 1344;
    },
    isFullHD() {
      return this.windowWidth >= 1344;
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
  },
  created() {
    this._onResize = this.onResize.bind(this);
  },
  mounted() {
    window.addEventListener('resize', this._onResize);
    this.onResize(); // Initial call
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onResize);
  },
};
